import __request__ from "routing/request";
export function create(request, requestOptions) {
  return __request__("POST", "/system/indices/index_sets/templates", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function builtIns(warm_tier_enabled, requestOptions) {
  return __request__("GET", "/system/indices/index_sets/templates/built-in", null, { "warm_tier_enabled": warm_tier_enabled }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getDefaultConfig(requestOptions) {
  return __request__("GET", "/system/indices/index_sets/templates/default_config", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPage(sort = "title", page = 1, per_page = 50, query, filters, order = "asc", requestOptions) {
  return __request__("GET", "/system/indices/index_sets/templates/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(id, request, requestOptions) {
  return __request__("PUT", `/system/indices/index_sets/templates/${id}`, request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function retrieveById(template_id, requestOptions) {
  return __request__("GET", `/system/indices/index_sets/templates/${template_id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(template_id, requestOptions) {
  return __request__("DELETE", `/system/indices/index_sets/templates/${template_id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
